import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import { RegistrationState } from "store/features/registration/types";
import { Requester } from "./requester";

export const getTripRequests = async () => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/trip-request/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getTripRequest = async (tripRequestId: string | null = "") => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/trip-request/${tripRequestId}/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const createTripResponse = async (
	tripRequestId: string,
	vehicle: string,
	driver: string
) => {
	const access_token = await getAccessToken();

	return Requester.post({
		url: `${baseConfig.baseURL}/trip-request/${tripRequestId}/response/`,
		body: {
			vehicle,
			driver
		},
		token: `${access_token}`,
		tokenType: "Bearer",
		success: (result): any => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const cancelTripResponse = async (tripRequestId: string | null = "") => {
	const access_token = await getAccessToken();

	return Requester.delete({
		url: `${baseConfig.baseURL}/trip-request/${tripRequestId}/response/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		success: (result): any => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
